import { Button as BButton, ButtonProps as BButtonProps } from "@heroui/react";

import { tv } from 'tailwind-variants';

export interface FieldSlots {
  base?:			string | string[];
  caption?:			string | string[];
  icon?:			string | string[];
}

export interface ButtonProps extends BButtonProps {
  caption?:		React.ReactNode;
  icon?:		React.ReactNode;
  width?:		string;
  layout?:		"default" | "white" | "warning" | "warning_bg";
  classNames?:	FieldSlots;
}

const btv = tv({
  slots: {
    base:		["px-[8px]", "py-[8px]", "text-white", "rounded-[4px]"],
    caption:	["m14", "leading-normal"],
    icon:		['material-icons', "!text-[--Light-Grey]", "text-[16px]"],
  },
  variants: {
    layout: {
      default: {
      },
      white: {
        base:			[	"text-[--Primetime-main]",
        					"bg-transparent",
        					"border-[--Primetime-main]",
        					"border-solid",
        					"border-1",
        					"px-[13px]",
        					"py-[7px]",
        				],
      },
      warning: {
        base:			["text-[--Warning]", "bg-transparent", "border-[--Warning]", "border-solid", "border-1"],
        caption:		["text-[--Warning]"],
        icon:			["!text-[--Warning]"]
      },
      warning_bg: {
        base:			["text-[--Light-Grey]", "bg-[--Warning]"],
        caption:		["text-[--Light-Grey]"],
        icon:			["!text-[--Light-Grey]"]
      },
    },
    disabled: {
      true:				[],
      false:			[],
    }
  },
  compoundVariants: [
    {
      layout: 'default',
      disabled: false,
      class: {
        base:			["bg-[--Primetime-main]"],
        caption:		["text-[--Light-Grey]"],
      }
    },
    {
      layout: 'default',
      disabled: true,
      class: {
        base:			["bg-[--Lines]"],
        caption:		["text-[--Mid-Grey]"],
      }
    },
    {
      layout: 'white',
      disabled: false,
      class: {
        caption:		["text-[--Primetime-main]"],
        icon:			["!text-[--Primetime-main]"],
      }
    },
    {
      layout: 'white',
      disabled: true,
      class: {
        base:			["bg-[--Lines]"],
      }
    },
    {
      layout: 'warning',
      disabled: true,
      class: {
        caption:		["text-[--Light-Grey]"],
      }
    },
    {
      layout: 'warning_bg',
      disabled: true,
      class: {
        //base:			["bg-[--Lines]"],
        //caption:		["text-[--Light-Grey]"],
        caption:		["text-[--Mid-Grey]"],
      }
    },
  ],
});

const Button = (bprops: ButtonProps) => {
  const {variant, caption, icon, width, className, layout, classNames, ...props} = bprops;
  
  const v = variant === undefined
  			?	"bordered"
  			:	variant;
  
  const l =	layout === undefined
  			?	"default"
  			:	layout;
  
  const w = width === undefined
  			?	(	icon
  					?	'min-w-[120px]'
  					:	'min-w-[72px]'
  				)
  			:	width;
  
  const cNames =	classNames === undefined
  					?	{}
  					:	classNames;
  
  const etv =	btv({
			      layout: 		l,
				  disabled:		props.isDisabled
								?	true
								:	false,
				});
  
  const c = typeof caption == "string"
  			?	<span className={etv.caption({className: cNames["caption"]})}>
				  { caption }
				</span>
    		:	caption;
  
  const i = typeof icon == "string"
  			?	<span className={etv.icon({className: cNames["icon"]})}>
      			  { icon }
    			</span>
    		:	icon;
  
  return (
  <BButton className={etv.base({className: cNames["base"]}) + (className ? ' ' + className : '')}
           {...props}>
    { i }
    { c }
  </BButton>
  );
}

export default Button;
